import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_HOUSEHOLD_UPDATE_APPLICATION,
} from 'api/actionTypes';

import updateLocalRenterProfile from 'client/actions/RenterProfile/updateLocalRenterProfile';
import updateCurrentUserRoleLimitedToursIfNeeded from 'client/actions/User/updateCurrentUserRoleLimitedToursIfNeeded';

export default async function updateRenterProfile({ state, apiClient }, {
  userId,
  stepId,
  prequalListingId,
  updates,
  queryId,
}) {
  typeCheck('userId::PositiveNumber', userId);
  typeCheck('prequalListingId::Maybe PositiveNumber', prequalListingId);
  typeCheck('stepId::Maybe NonEmptyString', stepId);
  typeCheck('updates::NonEmptyObject', updates);
  typeCheck('queryId::Maybe String', queryId);

  const renterProfile = updateLocalRenterProfile({ state }, { userId, updates });
  if (userId === state.get(['currentUser', 'id'])) {
    updateCurrentUserRoleLimitedToursIfNeeded({ state, apiClient }, { renterProfile });
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_UPDATE_APPLICATION,
    queryId: queryId || `${String(userId)}:${Object.keys(updates).join('_')}`,
    state: state,
    payload: {
      userId,
      stepId,
      prequalListingId,
      updates,
    },
  });
}
